import * as React from 'react';

function SvgHMobiledata(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			height='1em'
			viewBox='0 0 24 24'
			width='1em'
			className='svg-icon'
			{...props}>
			<path d='M0 0h24v24H0V0z' fill='none' />
			<path d='M15 11H9V7H7v10h2v-4h6v4h2V7h-2v4z' />
		</svg>
	);
}

export default SvgHMobiledata;
